<template>
    <div class="hello">
        <button @click="BtnClick">拍照</button>
    </div>
</template>

<script>
    export default {
        props: {},
        components: {},
        name: 'Test',
        data() {
            return {
            };
        },
        mounted() {
            plus.screen.lockOrientation( 'landscape-secondary');
            plus.screen.lockOrientation('landscape-primary') //主动旋转屏幕
        },
        created() {

        },
        methods: {
            BtnClick() {
                var cmr = plus.camera.getCamera();
                var res = cmr.supportedVideoResolutions[0];
                var fmt = cmr.supportedVideoFormats[0];
                console.log("Resolution: " + res + ", Format: " + fmt);
                cmr.startVideoCapture(function(path) {
                        alert("Capture video success: " + path);
                    },
                    function(error) {
                        alert("Capture video failed: " + error.message);
                    }, {
                        resolution: res,
                        format: fmt
                 });
            }
        }
    };
</script>
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/page/Test/Test.vue